// Number of failed jobs in the most recent pipeline run, for the Data Pipeline badge
// in the settings sidebar. Mirrors useDetectedSourcesCount: returns a plain number,
// and returns 0 while loading or on error -- a navigation badge must never render an
// error state, and SidebarItem renders nothing at 0.
import { useQuery } from "@tanstack/react-query";
import { getLastRunFailures } from "../views/data-imports/api";

// The backend's writeJSON wraps the payload under a named key, so the count arrives as
// { failures: { count: N } }. Anything unexpected reads as 0.
export function unwrapFailureCount(payload) {
  const count = payload?.failures?.count;
  return typeof count === "number" ? count : 0;
}

export function useLastRunFailureCount() {
  const { data } = useQuery({
    queryKey: ["pipeline-last-run-failures"],
    queryFn: getLastRunFailures,
    // The sidebar does not need the 10s cadence the Data Pipeline page uses.
    refetchInterval: 60000,
    // A failed request must leave the badge hidden, not retry-storm the nav.
    retry: false,
  });
  return unwrapFailureCount(data);
}
